<template>
  <div id="centerBottom">
    <!-- centerBottom -->
    <div class="lb-title">活动图片</div>
    <div class="swiper-pic">
      <swiper
        :options="swiperOption"
        @swiper="onSwiper"
        @slideChange="onSlideChange"
      >
        <swiper-slide>
          <div class="lp-img">
            <img src="@/assets/activity/1.jpg" alt="" />
            <img src="@/assets/activity/2.jpg" alt="" />
            <img src="@/assets/activity/3.jpg" alt="" />
            <img src="@/assets/activity/4.jpg" alt="" />
            <img src="@/assets/activity/5.jpg" alt="" />
            <img src="@/assets/activity/6.jpg" alt="" />
          </div>
        </swiper-slide>
        <swiper-slide>
          <div class="lp-img">
            <img src="@/assets/activity/7.jpg" alt="" />
            <img src="@/assets/activity/8.jpg" alt="" />
            <img src="@/assets/activity/9.jpg" alt="" />
            <img src="@/assets/activity/4.jpg" alt="" />
            <img src="@/assets/activity/5.jpg" alt="" />
            <img src="@/assets/activity/6.jpg" alt="" />
          </div>
        </swiper-slide>

        <!-- <div class="swiper-pagination"
           slot="pagination"></div>
      <div class="swiper-button-prev"
           slot="button-prev"></div>
      <div class="swiper-button-next"
           slot="button-next"></div> -->
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      swiperOption: {
        slidesPerView: 1,
        // 设置分页器
        // pagination: {
        //   el: '.swiper-pagination',
        //   // 设置点击可切换
        //   clickable: true
        // },
        // // 设置前进后退按钮
        // navigation: {
        //   nextEl: '.swiper-button-next',
        //   prevEl: '.swiper-button-prev'
        // },
        // 设置自动轮播
        autoplay: {
          delay: 5000, // 5秒切换一次
        },
        // 设置轮播可循环
        loop: true,
      },
    }
  },
  methods: {
    onSwiper() {},
    onSlideChange() {},
  },
}
</script>

<style lang="scss" scoped>
$box-height: 360px;
$box-width: 100%;
#centerBottom {
  padding: 20px;
  height: $box-height;
  width: $box-width;
  border-radius: 5px;
  .lb-title {
    width: 100%;
    font-size: 18px;
    font-weight: 500;
    color: rgb(158, 191, 232);
  }
  .swiper-pic {
    padding-left: 80px;
    padding-right: 80px;
    // margin-top: -25px;
    .lp-img {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      // margin-top: -10px;
      img {
        width: 29%;
        padding: 5px 0px;
        height: 150px;
      }
    }
  }
}
</style>
